<template>
    <div class='root'>
        <div class="dragable">
            <img src='/static/favicon_web.png'/>
            <span>&nbsp;{{t('__logo')}} </span>
        </div>
        <head_navigation class='header'/>
        <!-- 
        <transition name="fade">
            <router-view class='middle'/>
        </transition>
        -->

        <router-view v-if="!dialog || window_width>=1080" v-slot="{ Component }" class='middle'>
          <transition name="fade">
            <component :is="Component" />
          </transition>
        </router-view>
        <bottom v-if="!dialog || window_width>=1080" class='bottom'/>
    </div>
</template>


<script>
import { ref } from "vue"
import { useI18n } from "vue-i18n"
import head_navigation from './head_navigation.vue'
import bottom from './bottom.vue'

export default {
    setup() {
        let IS_ELECTRON=ref(process.env.VUE_APP_IS_ELECTRON != undefined ? 'block':'none')
        let window_width=window.screen.width
        let {t} = useI18n(
            {
                messages: {
                    'en': {
                        '__logo': "Python Atomic"
                    },
                    'zh_CN': {
                         "__logo": "Python共享类型"
                    },
                    'zh_HK': {
                         "__logo": "Python共享類型"
                    },
                    'zh_TW': {
                         "__logo": "Python共享類型"
                    }
                }
            }
        )
        let dialog=ref(false)
        return {t, dialog, IS_ELECTRON, window_width}
    },
    components:{
        head_navigation,
        bottom
    },
    mounted() {
        this.$emitter.on('dialog', ()=> {
            this.dialog=true
        })
        this.$emitter.on('dialog_finish', ()=> {
            this.dialog=false
        })
    },
}
</script>

<style scoped>

    .dragable {
        -webkit-app-region: drag;
        user-select: none;
        display: v-bind("IS_ELECTRON");
        height: 30px;
        position: sticky;
        top: 0;
        left: 0;
        width: 100%;
        background-color: white;
        z-index: 1000;
    }

    .dragable>img,.dragable>span {
        display: inline-block;
    }

    .dragable>span {
        height: 30px;
        line-height: 30px;
    }

    .dragable>img {
        width: 15px;
        height: 15px;
    }

    /* 定义淡入淡出动画的 CSS 类 */
    .fade-enter-active, .fade-leave-active {
      transition: opacity 1s ease; /* 过渡时长 0.5 秒，缓动函数 ease */
    }
    .fade-enter-from, .fade-leave-to {
      opacity: 0; /* 进入前/离开后：透明度为 0（不可见） */
    }
    .fade-enter-to, .fade-leave-from {
      opacity: 1; /* 进入后/离开前：透明度为 1（完全可见） */
    }

    .root {
        margin: 0 auto;
        position: relative;
    }
    
    .header {
        position: relative;
        top: 0;
    }
    
    .middle {
        position: relative;
        line-height: 150%;
    }

    .middle>>>.title,.middle>>>h1 {
        font-weight: 700;
    }
    
    .middle>>>.line {
        position: relative;
        margin-bottom: var(--margin-bottom);
    }
    
    .middle>>>.method.py>dd:nth-child(2),.middle>>>.function.py>dd:nth-child(2), .middle>>>.class.py>dd:nth-child(2) .attribute.py>dd:nth-child(2){
        position: relative;
    }
    
    .middle>>>.method.py>dd:nth-child(2)>>>.field-list > dd{
        position: relative;
    }
    
    .middle>>>.function.py>dd:nth-child(2)>>>.field-list > dd{
        position: relative;
    }
    
    .middle>>>.class.py>dd:nth-child(2)>>>.simple > dd{
        position: relative;
    }

    .middle>>>a{
        text-decoration: none;
    }

    .middle>>>a:link {
        color: red; /* 未访问链接颜色 */
    }
    .middle>>>a:visited {
    color: rgb(132, 0, 0); /* 已访问链接颜色 */
    }
    .middle>>>a:hover {
    color: red; /* 鼠标悬停时链接颜色 */
    }
    .middle>>>a:active {
    color: black; /* 点击时链接颜色 */
    }


@media screen and (max-width: 768px){

    .bottom {
        bottom: -7vw;
    }

    .header {
        height: 83vw;
    }

    .middle {
        font-size: 3vw;
        top: 6vw;
    }

    .middle>>>.button {
            --el-font-size-base: 3vw;
            height: 8vw;
        }

    .middle>>>h1 {
            margin-bottom: 1vw;
            font-size: 3vw;
        }

    .middle>>>div:nth-child(2) {
            margin-bottom: 1vw;
        }

    .middle>>>div:nth-child(3)>p{
            margin-bottom: 1.5vw;
        }
    
    .middle>>>.class.py>dt,.middle>>>.class.py>dd{
            margin-top: 2vw;
        }
    
    .middle>>>.method.py>dd:nth-child(2),.middle>>>.function.py>dd:nth-child(2),.middle>>>.class.py>dd:nth-child(2) .attribute.py>dd:nth-child(2){
            left: 6vw;
            width: 94vw;
        }
    
    .middle>>>.method.py>dd:nth-child(2) .field-list > dd{
            left: 8vw;
            width: 88vw;
        }
    
    .middle>>>.function.py>dd:nth-child(2) .field-list > dd{
            left: 4vw;
            width: 94vw;
        }
    
    .middle>>>.class.py>dd:nth-child(2) .simple > dd{
            left: 8vw;
            width: 88vw;
        }
    
    .middle>>>.class.py>dd:nth-child(2) > div:first-child{
            margin-bottom: 2vw;
        }
}

@media screen and (max-width: 1080px) and (min-width: 768px){

    .header {
        height: 56vw;
    }

    .middle {
        font-size: 2.6vw;
        top: -1vw;
    }
    
    .middle>>>.button {
            --el-font-size-base: 2.6vw;
            height: 8vw;
        }
    
    .middle>>>h1 {
            margin-bottom: 2vw;
            font-size: 2.6vw;
        }

    .middle>>>div:nth-child(2) {
            margin-bottom: 1vw;
        }

    .middle>>>div:nth-child(3)>p{
            margin-bottom: 1.5vw;
        }
    
    .middle>>>.class.py>dt,.class.py>dd{
            margin-top: 2vw;
        }
    
    .middle>>>.method.py>dd:nth-child(2),.middle>>>.function.py>dd:nth-child(2),.middle>>>.class.py>dd:nth-child(2) .attribute.py>dd:nth-child(2){
            left: 4vw;
            width: 96vw;
        }
    
    .middle>>>.method.py>dd:nth-child(2) .field-list > dd{
            left: 8vw;
            width: 92vw;
        }
    
    .middle>>>.function.py>dd:nth-child(2) .field-list > dd{
            left: 4vw;
            width: 96vw;
        }
    
    .middle>>>.class.py>dd:nth-child(2) .simple > dd{
            left: 8vw;
            width: 92vw;
        }
    
    .middle>>>.class.py>dd:nth-child(2) > div:first-child{
            margin-bottom: 2vw;
        }
}

@media (min-width: 1080px) {
    .root {
        width: 7.711rem;
    }

    .middle {
        font-size: 0.15rem;
        top: 0;
        padding-top: 0.05rem;
        bottom: 0;
        margin-top: 0;
    }

    .header {
        height: 2.8rem;
    }

    .middle>>>.button {
            --el-font-size-base: 0.15rem;
            height: 0.4rem;
        }
    
    .middle>>>h1 {
            margin-bottom: 0.15rem;
            font-size: 0.15rem;
        }
    
    .middle>>>.class.py>dt,.middle>>>.class.py>dd{
            margin-top: 0.15rem;
        }
    
    .middle>>>.method.py>dd:nth-child(2),.middle>>>.function.py>dd:nth-child(2),.middle>>>.class.py>dd:nth-child(2) .attribute.py>dd:nth-child(2){
            left: 0.2rem;
            width: 7.5rem;
        }
    
    .middle>>>.method.py>dd:nth-child(2) .field-list > dd{
            left: 0.4rem;
            width: 7.3rem;
    
        }
    
    .middle>>>.function.py>dd:nth-child(2) .field-list > dd{
            left: 0.4rem;
            width: 7.5rem;
        }
    
    .middle>>>.class.py>dd:nth-child(2) .simple > dd{
            left: 0.4rem;
            width: 7.3rem;
        }
    
    .middle>>>.class.py>dd:nth-child(2) > div:first-child{
            margin-bottom: 0.15rem;
        }
}

</style>